module.exports = __webpack_public_path__ + "static/media/V2_13.bcf662e7.png";